import { render } from "./App.vue?vue&type=template&id=3cbe86f9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/scss/app.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/vhstrejo/Sites/crowdfunding/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__